/**
 * Copy de manage: `stats.total` → “2 consultas”; `stats.unseen_total` → “1 nueva”.
 *
 * @param {{ total?: number, unseen?: number }} counts
 * @returns {{ totalLabel: string, unseenLabel: string }}
 */
export function formatCollectionInquiryCountLabels(counts = {}) {
  const total = Math.max(0, Math.trunc(Number(counts.total) || 0));
  const unseen = Math.max(0, Math.trunc(Number(counts.unseen) || 0));
  return {
    totalLabel: total > 0 ? (total === 1 ? '1 consulta' : `${total} consultas`) : '',
    unseenLabel: unseen > 0 ? (unseen === 1 ? '1 nueva' : `${unseen} nuevas`) : '',
  };
}

/**
 * Meta de card (manage): siempre un número, incluso cero.
 * @param {number} total
 * @returns {string}
 */
export function formatCollectionInquiryItemCountLabel(total) {
  const n = Math.max(0, Math.trunc(Number(total) || 0));
  return n === 1 ? '1 consulta' : `${n} consultas`;
}

/**
 * Lookup de `stats.by_item`. CAD: `parcel_id`. Lista: `lot_id` o `user_lot_id`.
 * Si el id no está, ese lote no tuvo consultas.
 *
 * @param {Record<string, { unseen: number, total: number }>|null|undefined} byItem
 * @param {...string} ids
 * @returns {{ unseen: number, total: number }|null}
 */
export function getCollectionInquiryItemCounts(byItem, ...ids) {
  if (!byItem || typeof byItem !== 'object') return null;
  for (const id of ids) {
    const key = String(id || '').trim();
    if (key && byItem[key]) return byItem[key];
  }
  return null;
}
